import ToAndFroDirectorySection, {
  TO_AND_FRO_DIRECTORY_COLUMN_DEFS,
  createInitialToFroColumnVisibility,
  toFroDefaultDirectoryFilters,
  toFroDirectoryCellValue,
} from "../../control/sections/ToAndFroDirectorySection";

export const OFFICE_TO_FRO_LIST_COLUMN_VISIBILITY_KEY =
  "girinestham.officeToFroDirectory.columnVisibility";

export function createOfficeToFroInitialColumnVisibility() {
  return createInitialToFroColumnVisibility(OFFICE_TO_FRO_LIST_COLUMN_VISIBILITY_KEY);
}

export default function OfficeToAndFroDirectorySection(props) {
  return (
    <ToAndFroDirectorySection
      {...props}
      sectionDomId="otf-list"
      columnVisibilityStorageKey={OFFICE_TO_FRO_LIST_COLUMN_VISIBILITY_KEY}
      directoryActionMode="office"
      directoryPaginationLabel="Office To and Fro directory pagination"
    />
  );
}

export {
  TO_AND_FRO_DIRECTORY_COLUMN_DEFS,
  toFroDefaultDirectoryFilters,
  toFroDirectoryCellValue,
};
